import React, { ReactNode } from "react";
import { Modal, Box } from "@mui/material";
import "./TJModal.scss";

export interface TJModalProps {
  open: boolean;
  onClose: () => void;
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  size?: "small" | "medium" | "large";
  width?: number | string;
}

const TJModal: React.FC<TJModalProps> = ({
  open,
  onClose,
  header,
  footer,
  children,
  size,
  width,
}) => {
  // Auto-detect size from child component if not provided
  let detectedSize: "small" | "medium" | "large" = "medium";
  if (!size && React.isValidElement(children)) {
    const childType = (children as any).type;
    if (childType && (childType as any).modalSize) {
      detectedSize = (childType as any).modalSize;
    }
  }
  const finalSize = size || detectedSize;

  // If width is provided, use it; otherwise use size
  const modalWidth = width 
    ? (typeof width === 'number' ? `${width}px` : width)
    : undefined;

  return (
    <Modal open={open} onClose={onClose}>
      <Box 
        className={`tj-modal ${!width ? `size-${finalSize}` : ''}`}
        sx={width ? { width: modalWidth } : undefined}
      >
        {header && (
          <Box className="tj-modal-header">
            {header}
          </Box>
        )}
        <Box className="tj-modal-body">
          {children}
        </Box>
        {footer && (
          <Box className="tj-modal-footer">
            {footer}
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default TJModal;

